export const server = 'https://track-me-backend.onrender.com'
export const foodApi = 'https://api.edamam.com'
export const imageApi = 'https://pixabay.com/api'
export const excerciseApi = 'https://trackapi.nutritionix.com'
